export default "__VITE_ASSET__8v$1_ndb__"